import { Observable } from 'rxjs';
import { PromotionDetailsResponse } from '../models/promotion-details.model';

export abstract class PromotionDetailsRepository {
    abstract getPromotionDetails(
        couponCode: string | null,
        couponUrl: string | null,
    ): Observable<PromotionDetailsResponse>;
}
